import { AwardingBodyIdentifiers } from "./AwardingBodyIdentifiers";
import { QualificationLevelIdentifiers } from "./QualificationLevelIdentifiers";

export enum QualificationLevelGroupIdentifiers {
  GCSEandIGCSE = 1,
  GCEALevelandASLevel = 2,
  InternationalALevel = 3,
  IGCSEAQA = 4,
  InternationalALevelAQA = 5,
}

export function GetQualificationLevelGroupIdForQualificationLevelId(awardingBodyId: AwardingBodyIdentifiers, qualificationLevelId : QualificationLevelIdentifiers) : number
{
  let qualificationLevelGroupId =  QualificationLevelGroupAndQualificationLevelRelations
    .find(x=> x.QualificationLevelId === qualificationLevelId && x.AwardingBodyId === awardingBodyId)
    ?.QualificationLevelGropuId

  if(!qualificationLevelGroupId)
    throw new Error(`Missing configuration for qlId: ${qualificationLevelId} and abId: ${awardingBodyId}`);

  return qualificationLevelGroupId;
}

const QualificationLevelGroupAndQualificationLevelRelations = [
  {
    QualificationLevelId: QualificationLevelIdentifiers.Gce,
    AwardingBodyId: AwardingBodyIdentifiers.Edexcel,
    QualificationLevelGropuId: QualificationLevelGroupIdentifiers.GCEALevelandASLevel,
  },
  {
    QualificationLevelId: QualificationLevelIdentifiers.ALevel,
    AwardingBodyId: AwardingBodyIdentifiers.Edexcel,
    QualificationLevelGropuId: QualificationLevelGroupIdentifiers.GCEALevelandASLevel,
  },
  {
    QualificationLevelId: QualificationLevelIdentifiers.ASLevel,
    AwardingBodyId: AwardingBodyIdentifiers.Edexcel,
    QualificationLevelGropuId: QualificationLevelGroupIdentifiers.GCEALevelandASLevel,
  },
  {
    QualificationLevelId: QualificationLevelIdentifiers.IGCSE,
    AwardingBodyId: AwardingBodyIdentifiers.Edexcel,
    QualificationLevelGropuId: QualificationLevelGroupIdentifiers.GCSEandIGCSE,
  },
  {
    QualificationLevelId: QualificationLevelIdentifiers.Gcse,
    AwardingBodyId: AwardingBodyIdentifiers.Edexcel,
    QualificationLevelGropuId: QualificationLevelGroupIdentifiers.GCSEandIGCSE,
  },
  {
    QualificationLevelId: QualificationLevelIdentifiers.Ial,
    AwardingBodyId: AwardingBodyIdentifiers.Edexcel,
    QualificationLevelGropuId: QualificationLevelGroupIdentifiers.InternationalALevel,
  },
  {
    QualificationLevelId: QualificationLevelIdentifiers.IGCSE,
    AwardingBodyId: AwardingBodyIdentifiers.AQA,
    QualificationLevelGropuId: QualificationLevelGroupIdentifiers.IGCSEAQA,
  },
  {
    QualificationLevelId: QualificationLevelIdentifiers.IAS_LEVEL,
    AwardingBodyId: AwardingBodyIdentifiers.AQA,
    QualificationLevelGropuId: QualificationLevelGroupIdentifiers.InternationalALevelAQA,
  },
  {
    QualificationLevelId: QualificationLevelIdentifiers.Ial,
    AwardingBodyId: AwardingBodyIdentifiers.AQA,
    QualificationLevelGropuId: QualificationLevelGroupIdentifiers.InternationalALevelAQA,
  },
];
